import { pick } from "@pathwright/ux/src/components/filestack/api"
import {
  BASE_FILESTACK_OPTIONS,
  MEDIA_TYPES
} from "@pathwright/ux/src/components/filestack/constants"
import {
  getOptions,
  getStoreTo
} from "@pathwright/ux/src/components/filestack/utils"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { AddAttachmentButton } from "../../Attachments/AttachmentsAdd/AttachmentsAdd"
import AttachmentsList from "../../Attachments/AttachmentsList/AttachmentsList"
import { submissionToAttachment } from "../utils"
import SubmitLink from "./SubmitLink"

const Submissions = ({
  files = [],
  mediaType,
  onAddFiles,
  onRemoveFile,
  onUpdateFile,
  theme,
  disableChanges,
  mediaStoragePath,
  blockID
}) => {
  const [error, setError] = useState(null)
  const { tc } = useTranslate()

  const pickFile = async () => {
    const fpOptions = getOptions(mediaType)
    const storeTo = getStoreTo(mediaStoragePath)

    const options = {
      ...fpOptions,
      storeTo,
      maxFiles: mediaType === "VIDEO" ? 1 : 20,
      fromSources: !mediaType
        ? [...BASE_FILESTACK_OPTIONS.fromSources]
        : [...fpOptions.fromSources]
    }

    const result = await pick(options)

    if (result.filesFailed.length) {
      return onPickError(
        `Failed to upload ${result.filesFailed
          .map((file) => `"${file.filename}"`)
          .join(", ")}`
      )
    }

    onPickSuccess(result.filesUploaded)
  }

  const onPickSuccess = (fpfiles) => {
    setError(null)
    onAddFiles(fpfiles)
  }

  const onPickError = (fperror) => {
    let error = null
    if (fperror.code !== 101) {
      error = fperror.toString()
    }
    console.error(error)
    setError(error)
  }

  const handleRemoveFile = (attachment) => {
    onRemoveFile(attachment)
  }

  const handleAddLink = (url) => {
    onAddFiles([url], true)
  }

  const handleUpdateFileName = (attachment) => {
    const nextFile = files.find((f) => f.id === attachment.id)
    if (!nextFile) return

    // convert attachment to file (submission)
    onUpdateFile({ ...nextFile, filename: attachment.name })
  }

  const attachments = files.map((f) => submissionToAttachment(f))

  return (
    <React.Fragment>
      {error ? (
        <div className="alert alert-error FilePickerUpload__error">{error}</div>
      ) : null}
      <AttachmentsList
        attachments={attachments}
        onRemoveAttachment={(attachment) => handleRemoveFile(attachment)}
        isDisabled={disableChanges}
        renderAddAttachment={() =>
          mediaType === MEDIA_TYPES.LINK ? (
            <SubmitLink
              onSubmit={handleAddLink}
              disableInput={disableChanges}
            />
          ) : (
            <AddAttachmentButton
              disabled={disableChanges}
              onClick={pickFile}
              label={tc("Add a File")}
            />
          )
        }
        onUpdateAttachmentName={handleUpdateFileName}
        mode={"edit"}
        blockID={blockID}
      />
    </React.Fragment>
  )
}

Submissions.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object),
  mediaStoragePath: PropTypes.string.isRequired,
  submitPrompt: PropTypes.string,
  mediaType: PropTypes.string.isRequired,
  onAddFiles: PropTypes.func,
  onRemoveFile: PropTypes.func,
  disableChanges: PropTypes.bool
}

export default Submissions
